import React, { FC } from 'react';
import { customFormatMessage } from 'utils';
import { IRootReducers } from 'src/reducers';

interface Props {
  customClass?: string;
  icon: string;
  text: string;
  link?: string;
  linkUrl?: string;
  qrScan?: boolean;
  value?: { [key: string]: number };
}

const mapStateToProps = (state: IRootReducers) => {
  return {
    user: state.auth.user,
  };
};

type OwnProps = ReturnType<typeof mapStateToProps> & Props;

const IconTextLink: FC<OwnProps> = ({
  customClass = '',
  icon,
  text,
  value,
}) => {
  return (
    <div className={`icon-text-link ${customClass}`}>
      <div className={`icon-text-link__icon icon icon--${icon}`} />
      <p className="regular-body icon-text-link__text">
        {customFormatMessage(text, value)}
      </p>
    </div>
  );
};

export default IconTextLink;
